/// <reference path='../_all.ts' />

module search {
  'use strict';

  export class searchService implements ISearchService {

    private keywordInputElement : JQuery = null;
    private keyword: string = null;
    private result: Results = <any>{};
    private getSearchResultDebounced: (keyword: string) => void;
    private applicationSearchRequestNo : number = 0;
    private partSearchRequestNo : number = 0;
    private documentSearchRequestNo : number = 0;
    private productArchiveSearchRequestNo: number = 0;
    private allProductsSearchRequestNo: number = 0;



    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$timeout',
      'debounce',
      '$http',
      '$rootScope',
      '$analytics',
      'pageMetaService',
      '$q',
    ];

    constructor(
      private $timeout: ng.ITimeoutService,
      private debounce: navigation.IDebounceService,
      private $http: ng.IHttpService,
      private $rootScope: ng.IRootScopeService,
      private $analytics :  angulartics.IAnalyticsService,
      private pageMetaService: navigation.IPageMetaService,
      private $q : ng.IQService
      ) {
      this.getSearchResultDebounced = debounce(this.search, 500, false);
    }


    public setKeywordInputElement(element:JQuery):void {
      this.keywordInputElement = $(element);
    }    

    public getKeywordInputElement():JQuery {
      return this.keywordInputElement;
    }

    public setKeyword(keyword: string) {
      if (keyword === this.keyword) return;
      if (keyword === '') {
        this.result = <any>{};
        this.$rootScope.$emit('search-service-data');
        return;
      }
      this.keyword = keyword;
      this.getSearchResultDebounced(keyword);
    }

    public subscribe(scope : ng.IScope, callback : (event:ng.IAngularEvent) => void) {
      var handler = this.$rootScope.$on('search-service-data', callback);
      if (scope) scope.$on('$destroy', handler);
    }

    public subscribeLoading(scope : ng.IScope, callback : (event:ng.IAngularEvent, ...args:any[]) => void) {
      var handler = this.$rootScope.$on('search-service-load', callback);
      if (scope) scope.$on('$destroy', handler);
    }

    public getData() : Results {
      return this.result;
    }

    //rStart und rCount werden zurzeit nie von der Startseite benutzt => Calling Search-Methoden nur mit Keyword
    private search(keyword : string) {
      this.$rootScope.$emit('search-service-load', true);
      this.$q.all([
        this.searchApplications(keyword),
        this.searchParts(keyword),
        this.searchLibrary(keyword),
        this.searchProductArchive(keyword),
      ]).then(()=>{
          this.$rootScope.$emit('search-service-load', false);
        },()=>{
          this.$rootScope.$emit('search-service-load', false);
        });
    }

    public searchApplications(keyword : string, resultStart: number = 0, resultCount: number = 5) : ng.IHttpPromise<ApplicationsSearchServiceData> {
      var rqCount = ++this.applicationSearchRequestNo;
      return this.$http<ApplicationsSearchServiceData>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Search"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          query: keyword,
          rStart: resultStart,
          rCount: resultCount
        }
      }).then((response : {data: ApplicationsSearchServiceData}) : any => {
        if (rqCount < this.applicationSearchRequestNo) return response;
        this.result.query = response.data.query;
        this.result.industries = { Hits: response.data.industries.Hits, Count: response.data.industries.Count };
        this.result.tasks = { Hits: response.data.tasks.Hits, Count: response.data.tasks.Count };
        this.result.products = { Hits: response.data.products.Hits, Count: response.data.products.Count };
        this.result.topResult = response.data.topResult;
        
        this.$rootScope.$emit('search-service-data');
        this.$analytics.pageTrack("/api/" + pglob.RouteData.CurrentLanguage.hl + "/Search/?query=" + this.keyword);
        return response;
      });

    }

    public searchParts(keyword: string, resultStart: number = 0, resultCount: number = 10): ng.IHttpPromise<PartSearchServiceData> {
      if (!this.pageMetaService.getPageMeta().RouteData.Features.Artikelsuche) {
        return;
      }
      
      var rqCount = ++this.partSearchRequestNo;
      return this.$http<PartSearchServiceData>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Part/Search"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          query: keyword,
          rStart: resultStart,
          rCount: resultCount
         }
      }).then((response : {data: PartSearchServiceData}) : any => {
        if (rqCount < this.partSearchRequestNo) return response;
        if (response.data) {
          this.result.query = response.data.Query;
          this.result.parts = { Hits: response.data.Hits, Count: response.data.Count };
        } else {
          response.data = new PartSearchServiceData(keyword, [], 0);
          this.result.parts = null;
        }
        this.$rootScope.$emit('search-service-data');
        return response;
      });
    }

    public searchLibrary(keyword: string, resultStart: number = 0, resultCount: number = 10, picturesOnly: boolean = false): ng.IHttpPromise<DocumentSearchServiceData> {
      var rqCount = ++this.documentSearchRequestNo;
      return this.$http<DocumentSearchServiceData>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Document/Search"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          query: keyword,
          rStart: resultStart,
          rCount: resultCount,
          picturesOnly: picturesOnly
         }
      }).then((response : {data: DocumentSearchServiceData}) : any => {
        if (rqCount < this.documentSearchRequestNo) return response;
        
        if (response.data) {
          this.result.query = response.data.Query;
          this.result.documents = { Hits: response.data.Hits, Count: response.data.Count };
        } else {
          response.data = new DocumentSearchServiceData(keyword, [], 0);
          this.result.documents = null;
        }
        this.$rootScope.$emit('search-service-data');
        return response;
        });
    }

    public searchAllProducts(keyword: string, resultStart: number = 0, resultCount: number = 5): ng.IHttpPromise<any> {
      var rqCount = ++this.allProductsSearchRequestNo;
      return this.$http<any>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Product/SearchAll"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          query: keyword,
          rStart: resultStart,
          rCount: resultCount
        }
      }).then((response: { data: any }) : any => {
        if (rqCount < this.allProductsSearchRequestNo) return response;
        if (response.data) {
          this.result.query = response.data.Query;
          this.result.allProducts = { Hits: response.data.Hits, Count: response.data.Count };
        } else {
          response.data = { Hits: [], Count: 0 };
          this.result.allProducts = null;
        }
        this.$rootScope.$emit('search-service-data');
        return response;
      })
    }

    public searchEverything(keyword: string, resultStart: number = 0, resultCount: number = 5): ng.IHttpPromise<AllSearchResult> {
      return this.$http<AllSearchResult>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Search/SearchEverything"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          query: keyword,
          rStart: resultStart,
          rCount: resultCount
        }
      }).then((response: { data: AllSearchResult }) : any => {
        return response;
      })
    }

    public searchProductArchive(keyword : string, resultStart: number = 0, resultCount: number = 5) : ng.IHttpPromise<ProductArchiveSearchServiceData> {
      var rqCount = ++this.productArchiveSearchRequestNo;
      return this.$http<ProductArchiveSearchServiceData>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Product/SearchArchive"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          query: keyword,
          rStart: resultStart,
          rCount: resultCount
         }
      }).then((response : {data: ProductArchiveSearchServiceData}) : any => {
        if (rqCount < this.productArchiveSearchRequestNo) return response;
        if (response.data) {
          this.result.query = response.data.Query;
          this.result.productArchive = { Hits: response.data.Hits, Count: response.data.Count };
        } else {
          response.data = new ProductArchiveSearchServiceData(keyword, [], 0);
          this.result.productArchive = null;
        }
        this.$rootScope.$emit('search-service-data');
        return response;
      });
    }


  }
}